import { render, staticRenderFns } from "./ResultOption.vue?vue&type=template&id=196da9f7&scoped=true&"
import script from "./ResultOption.vue?vue&type=script&lang=js&"
export * from "./ResultOption.vue?vue&type=script&lang=js&"
import style0 from "./ResultOption.vue?vue&type=style&index=0&id=196da9f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196da9f7",
  null
  
)

export default component.exports